import request from 'sb-request'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { reducers, getState } from 'redux/core'
import { modifyProduct } from 'common/helpers/modifiers/modifyResponse'


const fetch = (productId) => {
  reducers.view.productDetailsModal.setFetching(true)

  request.get(`rest/product/${productId}`, {
    modifyResult: modifyProduct,
  })
    .then(
      (result) => reducers.view.productDetailsModal.set(result),
      () => {
        actions.models.modals.close(constants.modals.ProductDetails)
        reducers.view.productDetailsModal.setFetching(false)
        return Promise.reject()
      }
    )
}

const setActiveVolumeIndex = (index) => reducers.view.productDetailsModal.setActiveVolumeIndex(index)

const getActiveVolume = (defaultSelectedQuickViewType) => {
  let { view: { productDetailsModal: { info: { volumes }, activeVolumeIndex } } } = getState()

  if (activeVolumeIndex === null) {
    if (defaultSelectedQuickViewType) {
      activeVolumeIndex = volumes.findIndex(({ actualType }) => actualType === defaultSelectedQuickViewType)
    }
    else {
      activeVolumeIndex = 0
    }
  }

  return volumes[activeVolumeIndex]
}

const handleStockNotificationSubscriptionSuccess = () =>
  reducers.view.productDetailsModal.setIsSubscribedToStockNotification(true)

// eslint-disable-next-line prefer-destructuring
const reset = reducers.view.productDetailsModal.reset


export default {
  fetch,
  reset,
  getActiveVolume,
  setActiveVolumeIndex,
  handleStockNotificationSubscriptionSuccess,
}
